<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
@import "assets/css/base.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
body{
  background-color: #f8f8f8;
}
*{
  margin: 0;
  padding: 0;
}
</style>
